import React from "react";
import useStyles from "../styles";
import WeekView from "./WeekView";
import Heading from "./Heading";

const MonthView = ({monthDays, selectedYear, selectedMonth, handleChangeMonth, useDay, setSelectedTime, checked, scrollRef}) => {
    const cl = useStyles();

    return (<div className={cl.monthWrapper}>
        <Heading selectedYear={selectedYear} selectedMonth={selectedMonth} handleChangeMonth={handleChangeMonth}
                 selectedDay={useDay[0]} checked={checked}/>
        {monthDays.map((week, idx) => (<WeekView key={'week'+idx} week={week} useDay={useDay} checked={checked} scrollRef={scrollRef}
                                                 handleChangeMonth={handleChangeMonth} setSelectedTime={setSelectedTime}/>))}
    </div>);
};

export default MonthView;
